const IDENTITY_WORD_PATTERN = /\b(?:raphael|raph|sinangote|angelo|quinto|acoba|arki|arkie|candelario|ian|gamao)\b/i;
const IDENTITY_COMPACT_PATTERN = /(?:johnraphael|raphaelsinangote|angeloquinto|acobaangelo|waynearkie|arkiecandelario|ianlance|lancegamao|gamaoian|danielquilatan)/i;
const IDENTITY_HANDLE_PATTERN = /(?:^|[\s@._+-])(?:raphael|raph|angelo|quinto|arki|arkie|ian|gamao)(?:\d|[\s@._+-]|$)/i;
let presentationPrivacyEnabled = false;

export const setPresentationPrivacyEnabled = (enabled) => {
  presentationPrivacyEnabled = enabled === true;
};

export const isPresentationPrivacyEnabled = () => presentationPrivacyEnabled;

export const containsPresentationIdentity = (value) => {
  if (typeof value !== 'string' || !value) return false;
  return IDENTITY_WORD_PATTERN.test(value)
    || IDENTITY_COMPACT_PATTERN.test(value.replace(/[^a-z0-9]/gi, ''))
    || IDENTITY_HANDLE_PATTERN.test(value);
};
